import React, {useState} from 'react';
import {
    Badge,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
} from "@material-ui/core";
import { useSelector} from "react-redux";
import {Button, Col, Row} from "reactstrap";
import CloseIcon from "@material-ui/icons/Close";
import BBDataTable from "../tables/BBDataTable";
import AddCommentsForm from "./AddCommentsForm";
import {

    bbFindEntityWithinPortfolioOrSelf,
    bbFormattedDateString
} from "../../../util/bbHelpers";
import BBIconCommentOutline from "../../../assets/bbCustomIcons/BBIconCommentOutline";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";




const VectorComments = ({customerId,
                            entityId,
                            vectorId = null,
                            cycleId=null,
                            testedVectorId,
                        })=>{

    const {loadingAddTag, loadingAddTagError, loadingUpdateTag, loadingUpdateTagError} = useSelector(({common})=> common);

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios,} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);


    const lastCycle = myEntity
    && myEntity.cycles
    && myEntity.settings
    && myEntity.settings.last_cycle_id
        ? myEntity.cycles[myEntity.settings.last_cycle_id] : null;

    const pastReportView = cycleId && lastCycle && cycleId !== lastCycle.id;

    const cycleInView = pastReportView
    && myEntity
    && myEntity.cycles
    && myEntity.cycles[cycleId]
        ? myEntity.cycles[cycleId]
        : lastCycle;

    const techData = myEntity
    && (lastCycle || cycleInView)
        ? cycleInView.techData
        : null;

    //in tech data, the threat vectors must be pulled from the techData, which holds more data than the BR Reports page
    const threatVectors = techData && techData.totals ? techData.totals.vectors : null;
    // console.log( "VectorScopeToggle tags", tags, "loadingAddTag", loadingAddTag, "testedVectorId", testedVectorId, "vectorId", vectorId)

    const indexOfVector = threatVectors && vectorId && threatVectors.findIndex(x => x.id === vectorId);
    const vector = threatVectors && vectorId && threatVectors[indexOfVector];

    const testedVectorDetails = vector
        && vector.tested_vector_details;

    const tags = testedVectorDetails && testedVectorDetails.tags && Object.values(testedVectorDetails.tags);

    const [open, setOpen] = useState(false);
    // const [viewHistory, setViewHistory] = useState(false);

    // const activeTags = tags && tags
    //     .filter((tag)=> tag.is_active)

    // console.log( "tags", tags, "loadingAddTag", loadingAddTag, "testedVectorId", testedVectorId, "vectorId", vectorId)

    const commentTags = tags
        ? tags
            .filter((tag)=> tag.definition && tag.definition.id === 43 && tag.is_active)
        :null;

    const hasComments = commentTags && Object.values(commentTags).length > 0;

    // const latestComment = hasComments
    //     ? commentTags
    //         .sort((a,b)=> b.date - a.date)
    //         .slice(0,1)
    //         .shift()
    //     : null

    // const dispatch = useDispatch();



    const columns= [
        { field: 'id', headerName: 'ID', hide: true, flex : 1, sortable: true, type: 'string',
            renderCell: (params) => {return params.value}},
        { field: 'added_by', headerName: 'Added By:', hide: false, width: 120, sortable: true, type: 'string', renderCell: (params) => {

                return params.value && params.value.name ? params.value.name : "--"}},
        { field: 'added_datetime', headerName: 'Date', hide: false, width: 100, sortable: true, type: 'string', renderCell: (params) => {

                return params.value ? bbFormattedDateString(params.value, "short") : "--"}},
        { field: 'details', headerName: 'Comment: ', hide: false, flex : 2, sortable: true, type: 'string', renderCell: (params) =>
            renderCellExpand(params, (
                <span>
                    {params.value ? params.value : null}
                </span>))
            },
    ]


    return(
        <div>
            <IconButton onClick={()=> setOpen(true)}
                    variant={"contained"}
                    color={"primary"}>
                    <Tooltip  title={`This element has ${commentTags ? Object.keys(commentTags).length : 0} comments.`}>
                            <Badge badgeContent={commentTags && Object.keys(commentTags).length}
                                   color={"primary"}>
                            <BBIconCommentOutline
                                style={{color: "black"}}/>
                        </Badge>
                    </Tooltip>
            </IconButton>

            <Dialog open={open}
                    fullScreen={false}
                    maxWidth={"md"}
                    className={"m-1 p-1 animated fadeIn animation-duration-7"}
                    aria-labelledby="form-dialog-title">
                <DialogTitle id="customized-dialog-title" className={"text-center"}>
                    <Row className={"m-0 p-0"}>
                        <Col className={"m-0 p-0"} lg={11}>
                            {pastReportView? null : "View Or Add Comments"}
                        </Col>
                        <Col>
                            <IconButton
                                onClick={()=>setOpen(false)}
                                style={{float: "right",margin: "0", padding: "0"}}>
                                <CloseIcon/>
                            </IconButton>
                        </Col>
                    </Row>
                </DialogTitle>
                <DialogContent>
                    {!pastReportView
                        ? <section id={"addCommentSection"}>
                            <Row className={"m-1 p-1"}>
                                <div className={"col-12"}>
                                    <h3>Add A New Comment</h3>
                                    <p>Add a new comment. Comments are visible to BreachBits staff and others in your organization.</p>
                                </div>
                            </Row>

                            <Row className={"m-1 p-1"}>
                                {!loadingAddTag[vectorId] && !loadingAddTagError[vectorId]
                                    ?
                                    <AddCommentsForm customerId={customerId}
                                                     vectorId={vectorId}
                                                     entityId={entityId}
                                                     testedVectorId={testedVectorId}
                                                     className={"col-12 text-center"}
                                    />
                                    : <CircularProgress/>
                                }
                                <Row/>
                            </Row>
                        </section>
                        : null}

                    <Row/>

                    <Row className={"m-1 p-1"}>
                        <Col className={"col-12"}>
                            <h3>View Previous Comments</h3>
                        </Col>
                    </Row>
                        {hasComments &&
                            <Row className={"col-12"}>
                                <BBDataTable
                                    columns={columns}
                                    rows={Object.values(commentTags)}
                                    disableColumnSelector
                                    disableDensitySelector
                                    disableColumnMenu
                                    disableColumnFilter
                                    progressValue={100}
                                    bufferValue={0}
                                    rowsPerPageOptions = {[3, 10, 25, 50, 100]}
                                    defaultPageSize = {3}
                                    defaultSortModel = {[
                                        {
                                            field: 'added_datetime',
                                            sort: 'desc',
                                        },

                                    ]}/>
                            </Row>}

                        {!hasComments &&
                            <Row>
                                <Col>
                                    <p className={"text-center col-12 m-1"}>
                                        <em>No comments history available...</em>
                                    </p>
                                </Col>
                            </Row>
                        }
                        <Row>
                            <Col className={"text-right"}>
                                <Button onClick={()=>setOpen(false)}
                                        className={"float-right mt-1"}
                                        variant={"contained"}
                                        color="primary"> Close </Button>
                            </Col>

                        </Row>

                </DialogContent>

            </Dialog>
        </div>
    )
}

export default VectorComments;
